"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditSiteMapLayerInfo = void 0;
var React = require("react");
var stateless_forms_1 = require("../../logistics/forms/stateless_forms");
var buttons_1 = require("../../buttons");
var CurrentSelection_1 = require("../../../services/CurrentSelection");
var SiteMapLayerForm_1 = require("./forms/SiteMapLayerForm");
function getLayerSelector(current_layer, layer_data) {
    return {
        name: "layer",
        label: gettext("Layer"),
        field_type: stateless_forms_1.SimpleFormFieldTypes.SELECT,
        value: current_layer === null || current_layer === void 0 ? void 0 : current_layer.id,
        required: false,
        options: layer_data.map(function (layer) { return [layer.id, layer.name]; }),
    };
}
var EditSiteMapLayerInfo = function (_a) {
    var site_id = _a.site_id, layer_data = _a.layer_data, layerSvc = _a.layerSvc;
    var _b = __read((0, CurrentSelection_1.useCurrentSelection)(0, layer_data), 2), getCurrentLayer = _b[0], setCurrentLayer = _b[1];
    var current_layer = getCurrentLayer();
    var _c = __read(React.useState(false), 2), isAddingNew = _c[0], setAddingNew = _c[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row align-items-end" },
            React.createElement("div", { className: "col" },
                React.createElement(stateless_forms_1.SimpleForm, { fields: [getLayerSelector(current_layer, layer_data)], onUpdate: function (name, value) {
                        setCurrentLayer(value);
                        setAddingNew(false);
                    }, valuesObject: layer_data })),
            React.createElement("div", { className: "col pb-1 mb-2" },
                React.createElement(buttons_1.Button, { className: "gamification-sidebar-button", onClick: function () {
                        setCurrentLayer(undefined);
                        setAddingNew(true);
                    } }, gettext("Add Layer")))),
        (current_layer || isAddingNew) && (React.createElement(SiteMapLayerForm_1.SiteMapLayerForm, { site_id: site_id, layer: current_layer, onSave: function (layer_data) {
                if (layer_data.id > 0)
                    layerSvc.update(layer_data, layer_data.id);
                else {
                    layerSvc.create(layer_data);
                }
                setAddingNew(false);
            }, onDelete: function (layer_data) {
                layerSvc.remove(layer_data.id);
                setAddingNew(false);
            } }))));
};
exports.EditSiteMapLayerInfo = EditSiteMapLayerInfo;
